import supercluster from "supercluster";
import { httpGet } from "@/services/api.service";
import {
  layerClickEventHandlerOn,
  layerClickEventHandlerOff,
} from "@/common/maps/eventHandler";
import { CLUSTER_LAYER_SUFFIX } from "@/common/constants/maps";

export { _addCluster as addCluster };
export { _removeCluster as removeCluster };
export { _getFeaturesInCluster as getFeaturesInCluster };
export { _addClusterClickEvent as addClusterClickEvent };

let clusters = {};

const _addCluster = async (map, sourceId, info, clusterOptions) => {
  delete clusters[sourceId];
  if (typeof info === "object" && info.features) {
    clusters[sourceId] = { isLoaded: true };
    _createCluster(map, sourceId, info.features, clusterOptions);
  } else if (typeof info === "string") {
    clusters[sourceId] = { isLoaded: false };
    const RESULT = await httpGet({ url: info });
    const { data } = JSON.parse(RESULT);
    if (clusters[sourceId] && data && data.features) {
      clusters[sourceId].isLoaded = true;
      _createCluster(map, sourceId, data.features, clusterOptions);
    }
  }
};

const _createCluster = (map, sourceId, features, clusterOptions) => {
  const NEW_CLUSTER = new supercluster(clusterOptions);
  NEW_CLUSTER.load(features);
  clusters[sourceId].superCluster = NEW_CLUSTER;
  if (clusterOptions.clusterMapClickEvent) {
    _addClusterClickEvent(map, sourceId, clusterOptions);
  }
};

const _removeCluster = (map, sourceId) => {
  if (clusters[sourceId]) {
    _removeClusterClickEvent(map, sourceId);
    delete clusters[sourceId];
  }
};

const _addClusterClickEvent = (map, sourceId, clusterOptions) => {
  _removeClusterClickEvent(map, sourceId);
  function mapClickEvent(e, features) {
    e.originalEvent.stopPropagation();
    if (features && features.length) {
      const CLUSTER_ID = features[0].properties.cluster_id;
      const SUPER_CLUSTER = clusters[sourceId].superCluster;
      const FEATURES_ARR = SUPER_CLUSTER.getLeaves(CLUSTER_ID, Infinity, 0);
      clusterOptions.clusterMapClickEvent(e, FEATURES_ARR);
    }
  }
  clusters[sourceId].mapClickEvent = mapClickEvent;
  const LAYER_ID = sourceId + CLUSTER_LAYER_SUFFIX;
  layerClickEventHandlerOn(map, LAYER_ID, mapClickEvent);
};

const _removeClusterClickEvent = (map, sourceId) => {
  const LAYER_ID = sourceId + CLUSTER_LAYER_SUFFIX;
  if (clusters[sourceId]) {
    layerClickEventHandlerOff(map, LAYER_ID);
  }
};

const _getFeaturesInCluster = (sourceId, clusterId, limit, offset) => {
  if (clusters[sourceId] && clusters[sourceId].superCluster) {
    const SOURCE_CLUSTER = clusters[sourceId].superCluster;
    limit = limit || Infinity;
    offset = offset || 0;
    return SOURCE_CLUSTER.getLeaves(clusterId, limit, offset);
  }
  return [];
};
